import { render, staticRenderFns } from "./NominaTransmitir.vue?vue&type=template&id=72d6aa9d"
import script from "./NominaTransmitir.vue?vue&type=script&lang=js"
export * from "./NominaTransmitir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports